export const compareVersions = (a, b) => {
  const v1 = a.version.split(".").map(Number);
  const v2 = b.version.split(".").map(Number);

  const length = Math.max(v1.length, v2.length);

  for (let i = 0; i < length; i++) {
    const num1 = v1[i] || 0;
    const num2 = v2[i] || 0;

    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }

  return 0;
};